import React from "react";
import Chip from "@mui/material/Chip";
import { useTheme } from "@mui/material/styles";
import type { ChipProps } from "@mui/material";
import { getDesignTokens } from "@/theme/designTokens";

type AppChipProps = ChipProps & {
  isActive?: boolean;
  variantType?: "default" | "filter" | "tag";
};

export function AppChip({ isActive = false, variantType = "default", sx, ...props }: AppChipProps) {
  const theme = useTheme();
  const tokens = getDesignTokens(theme);
  const baseStyle =
    variantType === "tag"
      ? {
          backgroundColor: tokens.tag.bestseller.bg,
          color: tokens.tag.bestseller.color,
          border: `1px solid ${tokens.border}`,
        }
      : variantType === "filter"
      ? {
          backgroundColor: `${isActive ? tokens.selection.surfaceSolid : tokens.surface} !important`,
          color: `${isActive ? tokens.selection.textOnSolid : tokens.textPrimary} !important`,
          border: `1px solid ${tokens.border}`,
        }
      : {
          backgroundColor: isActive ? tokens.selection.surfaceSolid : tokens.surface,
          color: isActive ? tokens.selection.textOnSolid : tokens.textPrimary,
          border: `1px solid ${tokens.border}`,
        };

  return (
    <Chip
      {...props}
      variant="outlined"
      sx={{
        ...baseStyle,
        borderRadius: "999px",
        fontWeight: 500,
        ...(sx ?? {}),
      }}
    />
  );
}

export default AppChip;

